import { useClassName } from '@/styles/Main';
import { PropsFromComponent } from '@/types/component';
import { GenericComponent } from 'base/components/GenericComponent';

export type MainProps = PropsFromComponent<typeof Main>;

export const Main = GenericComponent({ as: 'main', styles: { useClassName } });
